// extracted by mini-css-extract-plugin
export default {"DisabledInformTextContainer":"_DisabledInformTextContainer--eoI_K","DisabledInformText":"_DisabledInformText--FSQtt"};